import { useContext, useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from 'react-router';

import { NotificationType, PublicLead } from "shared/topchef.types";
import api from 'shared/topchef-api-places';
import Loading from "pages/shared/loading/Loading";
import PublicLeadContent from "pages/shared/public-lead-content/PublicLeadContent";
import { PlaceOutletContextType } from "pages/places/home/PlacesHome";
import { NotificationContext } from "shared/NotificationContext"
import { useErrorBoundary } from "react-error-boundary"
import FollowLeadButton from "./follow-lead-button/FollowLeadButton";

const AvailableLeadDetails = () => {

  const navigate = useNavigate();
  const [loggedInPlace] = useOutletContext<PlaceOutletContextType>();

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [publicLeadLoaded, setPublicLeadLoaded] = useState<boolean>(false);
  const [publicLead, setPublicLead] = useState<PublicLead | null>(null);

  const { showBoundary } = useErrorBoundary();

  useEffect(() => {

    async function loadPublicLead() {
      try {
        const lead: PublicLead = await api.loadPublicLead(loggedInPlace!.id, leadId);
        setPublicLead(lead);
        setPublicLeadLoaded(true);
      } catch (error: any) { 
        const newError = new Error(`Problème pour récupérer les détails du brief public : '${error.message}'`);
        triggerNotification({type: NotificationType.error, message : newError.message});
        return showBoundary(newError);
      } 
    }

    if (publicLeadLoaded) {
      return;
    }
    loadPublicLead();

  }, [publicLeadLoaded, publicLead, leadId, loggedInPlace, triggerNotification, showBoundary]);


  const followLead = async () => {
    try {
      await api.followLead(loggedInPlace!.id, leadId);
      navigate(`/places/leads/followed/${leadId}`);
    } catch (error: any) {
      triggerNotification({type: NotificationType.error, message : `Problème pour se positionner sur un brief : '${error.message}'`}); 
    }
  };

  function backToBriefMarket(): void {
    navigate('/places/available-leads');
  }

  if (!publicLeadLoaded) {
    return (
      <Loading />
    );
  }

  function isFollowAllowed(): boolean {
    return (publicLead!.status === 'available' || publicLead!.status === "followed") 
            && loggedInPlace!.id !== publicLead!.sourceId
            && publicLead!.availableSlots > 0;
  }

  return (

      <div className="container page-briefs-single-details p-2 col-md-6 overflow-auto">
        <div id="lead_sidebar" className="d-flex">
          <ul className="nav nav-pills flex-column mb-auto">
            <li className="nav-item"> <a href="/places/share-a-lead" type="button" className="btn btn-outline-primary nav-link add-brief-link">Ajouter un brief</a></li>
          </ul>
        </div>
       
        <PublicLeadContent publicLead={publicLead!} />

        <div className="text-center">
            <div className="text-center btn-list">
            {isFollowAllowed() &&
              <span className="position-instructions row mb-3">Vous souhaitez vous positionner sur ce brief ? Cliquez sur « Me positionner ». Vous verrez apparaitre les coordonnées du client. Nous comptons sur vous pour le contacter sous 24 à 48h. N’oubliez pas de « laisser votre place » si celui-ci ne donne pas suite à votre proposition afin qu’un autre lieu puisse se positionner ! Si vous contractualisez avec le client, cliquez sur « J’ai contractualisé avec ce lead ».</span>
            }
                <button id="cancel_brief_submission" className="cancel-btn btn btn-primary m-3" onClick={backToBriefMarket}>Retours aux briefs</button>
                {isFollowAllowed() ?
                  <FollowLeadButton followLead={followLead} loggedInPlace={loggedInPlace} lead={publicLead!}/>
                  :
                <div className="brief_slots_full mt-3">
                    <p className="text-danger">Vous ne pouvez pas vous positionner sur ce brief.</p>
                </div>
                }
            </div>
        </div>
    </div>
     
  );

}

export default AvailableLeadDetails;

